import { writable } from "svelte/store"
import type { ToastSettings } from "./ToastTypes"

export const ToastStore = writable<ToastSettings>({
	isOpen: false,
})
